import { removeLocalePrefix } from "./urlUtils";

// 确认是否为主页面  ( "/"" or "/en" )
export const checkIsHomePage = () => {
  const pathname = window.location.pathname;
  const isHomePage = removeLocalePrefix(pathname) === "/";

  return isHomePage;
};
